import { useApiClient } from '../../hooks/useApiClient.ts';
import { Role } from '../../types/Role/Role.type.ts';

export const useRoleApi = () => {
  const apiClient = useApiClient();

  return {
    getRoles: (): Promise<Role[]> => apiClient(`/roles/`),
  };
};
